<template>
  <Modal
    :show="shareDetails"
    justify-content="center"
    text-align="center"
    @close="shareDetails = false"
  >
    <template #header>Share Fundraiser</template>

    <div>
      <div class="flex">
        <Button
          class="p-button-outlined"
          :style="{ margin: '0 4px 0 0', width: '140px', justifyContent: 'center', color: '#000' }"
          @click="shareToPlatform('facebook')"
          data-test="share-facebook"
        >
          <Facebook />Facebook
        </Button>
        <Button
          class="p-button-outlined"
          :style="{ margin: '0 4px', width: '140px', justifyContent: 'center', color: '#000' }"
          @click="shareToPlatform('linkedin')"
          data-test="share-linkedin"
        >
          <LinkedIn />LinkedIn
        </Button>
      </div>
      <div class="flex">
        <Button
          class="p-button-outlined"
          :style="{ margin: '4px 4px 8px 0px', width: '140px', justifyContent: 'center', color: '#000' }"
          @click="shareToPlatform('twitter')"
          data-test="share-twitter"
        >
          <Twitter />Twitter
        </Button>
        <Button
          class="p-button-outlined"
          :style="{ margin: '4px 4px 8px 4px', width: '140px', justifyContent: 'center', color: '#000' }"
          @click="shareToPlatform('email')"
          data-test="share-email"
        >
          <Email />Email
        </Button>
      </div>
      <div style="text-align: left">Fundraiser URL</div>
      <InputText
        :value="fullUrl"
        :disabled="true"
        placeholder="Fundraiser URL"
        style="margin-bottom: 8px; width: 100%"
        data-test="fundraiser-url"
      />
      <div
        class="copy-url"
        @click="copyDefaultValue"
        data-test="copy-url"
        style="cursor: pointer; display: flex; align-items: center; margin-top: 8px"
      >
        <Copy
          fill="#000000"
          style="margin-right: 4px"
        />Copy To Clipboard
      </div>
    </div>

    <template #footer>
      <div></div>
      <Button
        class="p-button-filled"
        :style="{ width: '367px', display: 'flex', justifyContent: 'center' }"
        @click="shareDetails = false"
        data-test="close-modal"
      >
        Close
      </Button>
    </template>
  </Modal>
</template>
<script setup>
import { ref, computed, onBeforeMount, watch } from 'vue';
import getContrastYIQ from '@/helpers/getContrastYIQ';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
import { useRoute } from 'vue-router';
import filters from '@/helpers/filters';
import Export from '@/assets/Export.svg';
import PreviousArrow from '@/assets/PreviousArrow.svg';
import NextArrow from '@/assets/NextArrow.svg';
import Copy from '@/assets/Copy.vue';
import PencilBlack from '@/assets/PencilBlack.svg';
import Share from '@/assets/Share.svg';
import Eye from '@/assets/Eye.svg';
import Deactivate from '@/assets/Deactivate.svg';
import { useRouter } from 'vue-router';
import Modal from '@/components/Modal.vue';
import Facebook from '@/assets/Facebook.vue';
import LinkedIn from '@/assets/LinkedIn.vue';
import Twitter from '@/assets/Twitter.vue';
import Email from '@/assets/Email.vue';
import { useSnackbarStore } from '@/stores/SnackbarStore.js';
import useIsMobile from '@/composables/useIsMobile.js';

const donorStore = useDonorStore();
const fundraiserStore = useFundraiserStore();
const snackbarStore = useSnackbarStore();

const route = useRoute();
const shareDetails = ref(false);

const fundraiserId = parseInt(route.params.idOrName, 10);
const fundraiser = donorStore.getFundraiserById(fundraiserId);
const fullUrl = fundraiser.domain.replace(/\/$/, '') + '/fundraiser/' + fundraiser.urlLink;

// copy fundraiser url
const copyDefaultValue = () => {
  navigator.clipboard.writeText(fullUrl);
  // Show a toast notification to the user that the link was copied
  snackbarStore.show('Link Copied!', 'info');
};

//modal sharing options
const shareToPlatform = (platform) => {
  const text = `Check out this fundraiser: ${fundraiser.title}!`;
  let shareUrl = '';
  switch (platform) {
    case 'facebook':
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${fullUrl}&quote=${text}`;
      break;
    case 'linkedin':
      shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${fullUrl}&title=${text}`;
      break;
    case 'twitter':
      shareUrl = `https://twitter.com/intent/tweet?url=${fullUrl}&text=${text}`;

      break;
    case 'email':
      shareUrl = `mailto:?subject=Check out this fundraiser!&body=${text} ${fullUrl}`;

      break;
  }
  window.open(shareUrl, '_blank');
};
</script>
